export default "__VITE_ASSET__f8b4b710__"